import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import { transportModeSchema } from './domain/arrivalsBoard'

const arrivalsSearchSchema = z.object({
  mode: transportModeSchema.nullish().transform((data) => data ?? undefined),
})

export const arrivalsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/arrivals',
  validateSearch: arrivalsSearchSchema.parse,
  beforeLoad: ensureAuthenticatedUser,
}).lazy(() => import('./view/arrivalsBoard').then((module) => module.Route))
